import { css } from "@emotion/react";
import { HumburgerMenu } from ".";

const Header: React.FC = () => {
  return (
    <div css={mainStyle}>
      <a
        href="https://www.instagram.com/kuchinai_sakura/"
        target="_blank"
        rel="noopener"
      >
        <img
          src={process.env.REACT_APP_BASE_PATH + "/img/instagram.png"}
          css={iconStyle(0, 0)}
        />
      </a>
      <a
        href="https://twitter.com/kuchinai_sakura/"
        target="_blank"
        rel="noopener"
      >
        <img
          src={process.env.REACT_APP_BASE_PATH + "/img/x.png"}
          css={iconStyle(8, 4)}
        />
      </a>
      <HumburgerMenu />
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 30px 40px 0;
  display: flex;
  box-sizing: border-box;

  @media (max-width: ${spSize}px) {
    padding: 20px 12px 0;
  }
`;

const iconStyle = (marginLeft: number, spMarginLeft: number) => css`
  width: 65px;
  height: 65px;
  margin-left: ${marginLeft ? marginLeft : 0}px;

  @media (max-width: ${spSize}px) {
    width: 30px;
    height: 30px;
    margin-left: ${spMarginLeft ? spMarginLeft : 0}px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export default Header;
